import { IconButton } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	onClick: () => void;
	disabled?: boolean;
	children: ReactNode;
};

export const ChatComposerIconButton: FC<Props> = ({
	onClick,
	disabled,
	children,
}) => (
	<IconButton
		variant="ghost"
		onClick={onClick}
		disabled={disabled}
		sx={{ width: 36, height: 36 }}
	>
		{children}
	</IconButton>
);
